const user = {
  en: {
    user: {
      save: 'Save',
      permissions: 'Permissions',
      full_name: 'Name',
      editor_permissions: 'Editor Permissions',
      contact_details: 'Contact Details',
      permission: 'Permissions',
      created_at: 'Created At',
      last_sign_in_at: 'Last Sign In At',
      updated_at: 'Updated At',
      update_result: 'Update Results',
      create_user: 'Create User',
      status: 'Status',
      roles: 'Roles',
      teams: 'Teams',
      languages: 'Languages',
      first_name: 'First Name',
      last_name: 'Last Name',
      email: 'Email',
      address: 'Address',
      city: 'City',
      state: 'State',
      time_zone: 'Time Zone',
      phone: 'Phone',
      acl_teams: 'Access Control List Teams',
      acl_user_permissions: 'Additional permissions',
      can_create_articles: 'Can Create Articles',
      can_release_articles: 'Can Release Articles',
      can_take_ownership: 'Can Take Ownership',
      country: 'Country',
      projects: 'Projects',
      roles_list: {
        editor: 'Editor',
        admin: 'Admin',
        correspondent: 'Correspondent',
        full_access: 'Full Access',
        account_manager: 'Account Manager',
        outlet_manager: 'Outlet Manager',
        outlet_group_manager: 'Outlet Group Manager',
        code_editor: 'Code Editor',
        code_admin: 'Code Admin',
        analysis_researcher: 'Analysis Researcher',
        risala: 'Risala'
      },
      active: 'Active',
      inactive: 'Inactive',
      mfa_required: 'Require 2FA'
    }
  }
}

module.exports.user = user;